

























































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import UpdateBusinessHoursRequest from '@/models/BusinessHours/UpdateBusinessHoursRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import BusinessHoursDto from '@/models/BusinessHours/BusinessHoursDto';

@Component({
    name: 'BusinessHoursEdit'
})
export default class extends GiganautVueDialog {
 
  public entity = new BusinessHoursDto();

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(AgencySettingsModule.currentBusinessHours));
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateBusinessHoursRequest();
    request.updatedAt = this.entity.updatedAt;
    request.name = this.entity.name;
    request.isMon = this.entity.isMon;
    request.monOpenAt = this.entity.monOpenAt;
    request.monCloseAt = this.entity.monCloseAt;
    request.isTue = this.entity.isTue;
    request.tueOpenAt = this.entity.tueOpenAt;
    request.tueCloseAt = this.entity.tueCloseAt;
    request.isWed = this.entity.isWed;
    request.wedOpenAt = this.entity.wedOpenAt;
    request.wedCloseAt = this.entity.wedCloseAt;
    request.isThu = this.entity.isThu;
    request.thuOpenAt = this.entity.thuOpenAt;
    request.thuCloseAt = this.entity.thuCloseAt;
    request.isFri = this.entity.isFri;
    request.friOpenAt = this.entity.friOpenAt;
    request.friCloseAt = this.entity.friCloseAt;
    request.isSat = this.entity.isSat;
    request.satOpenAt = this.entity.satOpenAt;
    request.satCloseAt = this.entity.satCloseAt;
    request.isSun = this.entity.isSun;
    request.sunOpenAt = this.entity.sunOpenAt;
    request.sunCloseAt = this.entity.sunCloseAt;

   
    await AgencySettingsModule.editBusinessHours(request);
    this.dialog = false;
  }
}
